import React, { useEffect, useRef, useState } from 'react';
import './Home.css';
import Header from '../Header/Header';
import { GoArrowUpRight } from "react-icons/go";
import CountUp from 'react-countup';
import Footer from '../Footer/Footer';
import FollowUs from '../Footer/FollowUs';
import CustomCursor from '../../CustomCursor';
import { motion } from "framer-motion";
// import Slider from 'react-slick';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
 
const useOnScreen = (options) => {
    const [isIntersecting, setIsIntersecting] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setIsIntersecting(entry.isIntersecting);
        }, options);

        const currentRef = ref.current;

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [options]);

    return [ref, isIntersecting];
};

// const ArrowUp = (props) => (
//     <div
//         className="arrow_up_testimonials"
//         onClick={props.onClick}
//     >
//         &uarr;
//     </div>
// );

// const ArrowDown = (props) => (
//     <div
//         className="arrow_down_testimonials"
//         onClick={props.onClick}
//     >
//         &darr;
//     </div>
// );

const Home = () => {
    const [ref, isVisible] = useOnScreen({ threshold: 0.1 });

    const [OurWorkVisible, setOurWorkVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const currentRef = sectionRef.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setOurWorkVisible(true);
                } else {
                    setOurWorkVisible(false);
                }
            },
            { threshold: 0.1 }
        );

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    // const [scrollDirection, setScrollDirection] = useState('slide_container');

    // useEffect(() => {
    //     let lastScrollY = window.scrollY;

    //     const handleScroll = () => {
    //         const currentScrollY = window.scrollY;

    //         if (currentScrollY > lastScrollY) {
    //             setScrollDirection('slide_reverse');
    //         } else {
    //             setScrollDirection('slide_container');
    //         }

    //         lastScrollY = currentScrollY;
    //     };

    //     window.addEventListener('scroll', handleScroll);

    //     return () => {
    //         window.removeEventListener('scroll', handleScroll);
    //     };
    // }, []);

    // const [isContentVisible1, setContentVisible1] = useState(false);

    // const toggleContent1 = () => {
    //     setContentVisible1(!isContentVisible1);
    // };

    // const [isContentVisible2, setContentVisible2] = useState(false);

    // const toggleContent2 = () => {
    //     setContentVisible2(!isContentVisible2);
    // };

    // const [isContentVisible3, setContentVisible3] = useState(false);

    // const toggleContent3 = () => {
    //     setContentVisible3(!isContentVisible3);
    // };

    // const [isContentVisible4, setContentVisible4] = useState(false);

    // const toggleContent4 = () => {
    //     setContentVisible4(!isContentVisible4);
    // };

    // const [isContentVisible5, setContentVisible5] = useState(false);

    // const toggleContent5 = () => {
    //     setContentVisible5(!isContentVisible5);
    // };

    const [openIndex, setOpenIndex] = useState(null);

    const toggleContent = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    

    // const settings1 = {
    //     vertical: true,
    //     verticalSwiping: true,
    //     infinite: true,
    //     slidesToShow: 2,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     dots: false,
    //     speed: 500,
    //     autoplay: true,
    //     autoplaySpeed: 5000,
    //     prevArrow: <ArrowUp />,
    //     nextArrow: <ArrowDown />,
    // };

    // const settings2 = {
    //     vertical: true,
    //     verticalSwiping: true,
    //     infinite: true,
    //     slidesToShow: 2.2,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     dots: false,
    //     speed: 500,
    //     autoplay: true,
    //     autoplaySpeed: 3000,
    //     prevArrow: <ArrowUp />,
    //     nextArrow: <ArrowDown />,
    // };

    const [activeFAQ, setActiveFAQ] = useState(null);

    const toggleFAQContent = (faqIndex) => {
        setActiveFAQ(faqIndex === activeFAQ ? null : faqIndex);
    };

  const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

    return (
        <div className='text-[14px] md:text-xl lg:text-[17px] 2xl:text-xl leading-7 md:leading-8 lg:leading-7 2xl:leading-10 overflow-x-hidden'>
            <Header /><br />
            <CustomCursor />
            <div className='mt-[40px] lg:mt-[45px]'>

                {/* Hero section starts from here */}
                <div className="relative rounded-xl p-[2%] m-[3%]">
                    <img
                        src="../assets/ex1.png"
                        alt="Background"
                        className="absolute inset-0 h-full w-full object-cover rounded-xl"
                    />
                    <div className="relative flex justify-between items-end h-[100vw] md:h-[38vw] w-full">
                        <p className="heading text-6xl md:text-8xl lg:text-9xl 2xl:text-[10rem] z-10">
                            <span className="text-[#F56E0F]">YOUR BRAND’S</span><br />
                            <span className='text-white'>FAVOURITE STUDIO</span>
                        </p>
                        {/* <button className="group relative h-[5.5em] w-[5.5em] lg:h-[10em] lg:w-[10em] hover:scale-90 z-10 transition-transform duration-300 rounded-full hover:bg-black hover:bg-opacity-60">
                            <img
                                src="../assets/circularText.webp"
                                alt="Circular Text"
                                className="absolute inset-0 h-full w-full object-cover custom_spin"
                            />
                            <GoArrowUpRight className="absolute inset-0 m-auto text-white text-[2em] lg:text-[3em] flex justify-center items-center" />
                        </button> */}
                    </div>
                </div>
                {/* Hero section ends here */}

                {/* About us starts from here */}
                <div className='mt-[5%] lg:mt-[2%] mx-[3%] lg:mx-[8%]'>
                    <div className='grid grid-cols-1 lg:grid-cols-2 items-center'>
                        <div>
                            <p className='flex items-center'><div className='h-1 w-1 bg-[#F56E0F] rounded-full'></div>&nbsp;About Us</p>
                            <div className='heading text-4xl md:text-6xl lg:text-7xl my-[2%] uppercase'>
                                Where Brilliant<br />
                                IDEAS <span className='text-[#F56E0F]'>Take Shape</span>
                            </div>
                        </div>

                        <div>
                            At Open Studios, we believe every strong idea deserves the perfect platform to thrive. As
                            a team of passionate creatives, we transform ideas into visuals, brands, and experiences
                            that leave a lasting impact.
                        </div>
                    </div>

                    <div className='mt-[5%] lg:mt-[2%] lg:grid lg:grid-cols-2'>
                        <span className='font-semibold'>Open Studio in Number</span>
                        <div className='flex justify-between lg:mx-[0%]' ref={ref}>
                            <div>
                                Projects completed
                                <p className='heading text-4xl md:text-6xl lg:text-7xl text-center'>
                                    {isVisible && <CountUp end={600} suffix='+' duration={5} />}
                                </p>
                            </div>

                            <div>
                                Client retention rate
                                <p className='heading text-4xl md:text-6xl lg:text-7xl text-center'>
                                    {isVisible && <CountUp end={95} suffix='%' duration={5} />}
                                </p>
                            </div>

                            <div>
                                Years of experience
                                <p className='heading text-4xl md:text-6xl lg:text-7xl text-center'>
                                    {isVisible && <CountUp end={7} suffix=' YRS' duration={10} />}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* About us ends here */}

                {/* Logo slider strip starts from here */}
                {/* <div className={`slider mt-[6%] lg:mt-[3%]`}>
                        <div className={scrollDirection}> */}
                 <div className="w-full overflow-hidden my-16">
            
            <div className="slider">
            <div className="slide-track">
                {[
                "../assets/openStudios_logo.webp",
                "../assets/colorful_logo.png",
                "../assets/openStudios_logo.webp",
                "../assets/colorful_logo.png",
                "../assets/openStudios_logo.webp",
                "../assets/colorful_logo.png",
                "../assets/openStudios_logo.webp",
                "../assets/colorful_logo.png",
                "../assets/openStudios_logo.webp",
                "../assets/colorful_logo.png",
                "../assets/openStudios_logo.webp",
                "../assets/colorful_logo.png",
                "../assets/openStudios_logo.webp",
                "../assets/colorful_logo.png",
                ]
                .concat([
                    "../assets/openStudios_logo.webp",
                    "../assets/colorful_logo.png",
                    "../assets/openStudios_logo.webp",
                    "../assets/colorful_logo.png",
                    "../assets/openStudios_logo.webp",
                    "../assets/colorful_logo.png",
                    "../assets/openStudios_logo.webp",
                    "../assets/colorful_logo.png",
                    "../assets/openStudios_logo.webp",
                    "../assets/colorful_logo.png",
                    "../assets/openStudios_logo.webp",
                    "../assets/colorful_logo.png",
                    "../assets/openStudios_logo.webp",
                    "../assets/colorful_logo.png",
                ])
                .map((src, i) => (
                    <div className="slide" key={i}>
                    <img src={src} alt="logo" className="slide-img" />
                    </div>
                ))}
            </div>

            <style>
                {`
                .slider {
                    background: white;
                    box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.125);
                    height: 120px;
                    overflow: hidden;
                    position: relative;
                    width: 100%;
                }

                .slider::before,
                .slider::after {
                    content: "";
                    position: absolute;
                    width: 200px;
                    height: 100%;
                    z-index: 2;
                    background: linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
                    top: 0;
                }

                .slider::after {
                    right: 0;
                    transform: rotateZ(180deg);
                }

                .slider::before {
                    left: 0;
                }

                .slide-track {
                    display: flex;
                    width: calc(250px * 28);
                    animation: scroll 40s linear infinite;
                }

                .slide {
                    width: 250px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                @keyframes scroll {
                    0% {
                    transform: translateX(0);
                    }
                    100% {
                    transform: translateX(calc(-250px * 14));
                    }
                }

                /* Grayscale hover effect */
                .slide-img {
                    height: 70px;
                    object-fit: contain;
                    filter: grayscale(100%);
                    transition: all 0.5s ease-in-out;
                }

                .slide-img:hover {
                    filter: grayscale(0%);
                    transform: scale(1.1);
                }
                `}
            </style>
            </div>
        </div>

                {/* Our work starts from here */}
                <div
                    className={`mt-[5%] lg:mt-[2%] bg-[#1A1919] rounded-2xl py-[2%] ${OurWorkVisible ? 'fade_in' : 'fade_out'}`}
                    ref={sectionRef}
                >
                    <div>
                        <p className='flex items-center text-white justify-center'>
                            <div className='h-1 w-1 bg-[#F56E0F] rounded-full'></div>&nbsp;Our Works
                        </p>
                        <p className='heading text-4xl md:text-6xl lg:text-7xl my-[2%] text-white text-center uppercase'>
                            MAKING IDEAS IN ACTION
                        </p>
                    </div>

                    <div className='grid grid-cols-1 lg:grid-cols-2 mx-[3%] lg:mx-[8%]'>

                        <div className='m-[3%] lg:my-0'>
                            <div className='lg:-mb-[8%] -mb-[9%] lg:ml-0 ml-2 text-[1.9vw] lg:text-[1vw]'>
                                <button className='bg-[#3A3939] text-[#B5B3B3] px-[1.3%] py-[0.5%] rounded-full mx-1 cursor-pointer'>Photography</button>
                                <button className='bg-[#3A3939] text-[#B5B3B3] px-[1.3%] py-[0.5%] rounded-full cursor-pointer'>Cinematography</button>
                            </div>
                            <div className="card_ourWork">
                                {/* <div className="card-details_ourWork">
                                    <img src="../assets/soham_villas.webp" alt="Img" className='h-[66vw] lg:h-[31vw] w-auto' />
                                </div> */}
                                <motion.div
                                    variants={fadeUp}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.3 }}
                                    className="card-details_ourWork"
                                >
                                <img src="../assets/soham_villas.webp" alt="Img" className='h-[65vw] lg:h-[31vw] w-auto' />
                                </motion.div>
                                {/* <button className="card-button_ourWork">More info</button> */}
                            </div>
                            <div className='mt-[3%]'>
                                <p className='flex items-center text-[#B5B3B3] my-[5%] lg:my-[2%]'>2023&nbsp;<div className='h-1 w-1 bg-[#F56E0F] rounded-full'></div>&nbsp;ARCHITECTURE | HOSPITALITY</p>
                                <p className='heading text-4xl md:text-6xl lg:text-7xl my-[2%] text-white uppercase'>Soham Villas</p>
                            </div>
                        </div>

                        {/* <div className='m-[3%] lg:my-0 lg:mt-[10%]'>
                            <div className="card_ourWork"> */}
                                {/* <div className="card-details_ourWork">
                                    <img src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/436ddcaf-4b70-49f7-cd1c-dc96f872b000/public"
                                    // src="https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/201407251639545172-38b2a64a58c011eb8a8f0242ac110004.jpg" 
                                    alt="Img" className='h-[66vw] lg:h-[31vw] w-auto rounded-3xl' />
                                </div> */}
                                {/* <motion.div
                                    variants={fadeUp}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.3 }}
                                    className="card-details_ourWork">
                                    <img src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/436ddcaf-4b70-49f7-cd1c-dc96f872b000/public"
                                    // src="https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/201407251639545172-38b2a64a58c011eb8a8f0242ac110004.jpg" 
                                    alt="Img" className='h-[66vw] lg:h-[31vw] w-auto rounded-3xl' />    
                                    </motion.div>
                                <button className="card-button_ourWork">More info</button>
                            </div>
                            <div className='mt-[3%]'>
                                <p className='flex items-center text-[#B5B3B3] my-[5%] lg:my-[2%]'>2022&nbsp;<div className='h-1 w-1 bg-[#F56E0F] rounded-full'></div>&nbsp;ARCHITECTURE | HOSPITALITY</p>
                                <p className='heading text-4xl md:text-6xl lg:text-7xl my-[2%] text-white uppercase'>Rpj Hotel</p>
                            </div>
                        </div> */}
                        <div className='m-[3%] lg:my-0 lg:mt-[10%]'>
                            <div className='lg:-mb-[8%] -mb-[9%] lg:ml-0 ml-2  text-[1.9vw] lg:text-[1vw]'>
                                <button className='bg-[#3A3939] text-[#B5B3B3] px-[1.3%] py-[0.5%] rounded-full mx-1 cursor-pointer'>Photography</button>
                                <button className='bg-[#3A3939] text-[#B5B3B3] px-[1.3%] py-[0.5%] rounded-full cursor-pointer'>Cinematography</button>
                            </div>
                            <div className="card_ourWork">
                                {/* <div className="card-details_ourWork">
                                    <img src="../assets/soham_villas.webp" alt="Img" className='h-[66vw] lg:h-[31vw] w-auto' />
                                </div> */}
                                <motion.div
                                    variants={fadeUp}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.3 }}
                                    className="card-details_ourWork"
                                >
                                <img src="../assets/soham_villas.webp" alt="Img" className='h-[65vw] lg:h-[31vw] w-auto' />
                                </motion.div>
                                {/* <button className="card-button_ourWork">More info</button> */}
                            </div>
                            <div className='mt-[3%]'>
                                <p className='flex items-center text-[#B5B3B3] my-[5%] lg:my-[2%]'>2023&nbsp;<div className='h-1 w-1 bg-[#F56E0F] rounded-full'></div>&nbsp;ARCHITECTURE | HOSPITALITY</p>
                                <p className='heading text-4xl md:text-6xl lg:text-7xl my-[2%] text-white uppercase'>Rpj Hotel</p>
                            </div>
                        </div>

                        {/* <div className='m-[3%] lg:my-0'>
                            <div className="card_ourWork">
                                <motion.div
                                    variants={fadeUp}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.3 }}
                                    className="card-details_ourWork">
                                    <img src="https://lh3.googleusercontent.com/p/AF1QipMh2FObA2eiTMvbAWRdyijgbwPzk8y-6dbeHmG3=s1360-w1360-h1020-rw" alt="Img" className='h-[66vw] lg:h-[31vw] w-auto rounded-3xl' />
                                </motion.div>
                                <button className="card-button_ourWork">More info</button>
                            </div>
                            <div className='mt-[3%]'>
                                <p className='flex items-center text-[#B5B3B3] my-[5%] lg:my-[2%]'>2023&nbsp;<div className='h-1 w-1 bg-[#F56E0F] rounded-full'></div>&nbsp;MODEL | JEWELLERY </p>
                                <p className='heading text-4xl md:text-6xl lg:text-7xl my-[2%] text-white uppercase'>Sygnet Jewel</p>
                            </div>
                        </div> */}
                        <div className='m-[3%] lg:my-0'>
                            <div className='lg:-mb-[8%] -mb-[9%] lg:ml-0 ml-2  text-[1.9vw] lg:text-[1vw]'>
                                <button className='bg-[#3A3939] text-[#B5B3B3] px-[1.3%] py-[0.5%] rounded-full mx-1 cursor-pointer'>Photography</button>
                                <button className='bg-[#3A3939] text-[#B5B3B3] px-[1.3%] py-[0.5%] rounded-full cursor-pointer'>Cinematography</button>
                            </div>
                            <div className="card_ourWork">
                                {/* <div className="card-details_ourWork">
                                    <img src="../assets/soham_villas.webp" alt="Img" className='h-[66vw] lg:h-[31vw] w-auto' />
                                </div> */}
                                <motion.div
                                    variants={fadeUp}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.3 }}
                                    className="card-details_ourWork"
                                >
                                <img src="../assets/soham_villas.webp" alt="Img" className='h-[65vw] lg:h-[31vw] w-auto' />
                                </motion.div>
                                {/* <button className="card-button_ourWork">More info</button> */}
                            </div>
                            <div className='mt-[3%]'>
                                <p className='flex items-center text-[#B5B3B3] my-[5%] lg:my-[2%]'>2023&nbsp;<div className='h-1 w-1 bg-[#F56E0F] rounded-full'></div>&nbsp;MODEL | JEWELLERY </p>
                                <p className='heading text-4xl md:text-6xl lg:text-7xl my-[2%] text-white uppercase'>Sygnet Jewel</p>
                            </div>
                        </div>

                        {/* <div className='m-[3%] lg:my-0 lg:mt-[10%]'>
                            <div className="card_ourWork">
                                <motion.div
                                    variants={fadeUp}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.3 }}
                                    className="card-details_ourWork">
                                    <img src="https://media.licdn.com/dms/image/v2/C4E1BAQFLE7CHo2qRug/company-background_10000/company-background_10000/0/1637822493270/hariom_interior_cover?e=2147483647&v=beta&t=ItWvjLbC0yXku20WV5IRQBbEo7K-4QWn9ejxAopAtO0" alt="Img" className='h-[66vw] lg:h-[31vw] w-auto rounded-3xl' />    
                                </motion.div>
                                <button className="card-button_ourWork">More info</button>
                            </div>
                            <div className='mt-[3%]'>
                                <p className='flex items-center text-[#B5B3B3] my-[5%] lg:my-[2%]'>2023&nbsp;<div className='h-1 w-1 bg-[#F56E0F] rounded-full'></div>&nbsp;INTERIOR | ARCHITECTURE</p>
                                <p className='heading text-4xl md:text-6xl lg:text-7xl my-[2%] text-white uppercase'>Hari Aum Designs</p>
                            </div>
                        </div> */}
                        <div className='m-[3%] lg:my-0 lg:mt-[10%]'>
                            <div className='lg:-mb-[8%] -mb-[9%] lg:ml-0 ml-2  text-[1.9vw] lg:text-[1vw]'>
                                <button className='bg-[#3A3939] text-[#B5B3B3] px-[1.3%] py-[0.5%] rounded-full mx-1 cursor-pointer'>Photography</button>
                                <button className='bg-[#3A3939] text-[#B5B3B3] px-[1.3%] py-[0.5%] rounded-full cursor-pointer'>Cinematography</button>
                            </div>
                            <div className="card_ourWork">
                                <motion.div
                                    variants={fadeUp}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.3 }}
                                    className="card-details_ourWork"
                                >
                                <img src="../assets/soham_villas.webp" alt="Img" className='h-[65vw] lg:h-[31vw] w-auto' />
                                </motion.div>
                                {/* <button className="card-button_ourWork">More info</button> */}
                            </div>
                            <div className='mt-[3%]'>
                                <p className='flex items-center text-[#B5B3B3] my-[5%] lg:my-[2%]'>2023&nbsp;<div className='h-1 w-1 bg-[#F56E0F] rounded-full'></div>&nbsp;INTERIOR | ARCHITECTURE</p>
                                <p className='heading text-4xl md:text-6xl lg:text-7xl my-[2%] text-white uppercase'>Hari Aum Designs</p>
                            </div>
                        </div>
                    </div>

                    {/* <div className='flex justify-center mt-[5%] lg:mt-[2%]'>
                        <div className='joint_btn arrow_btn-wrapper bg-[#F56E0F] text-base py-1 px-[2.5%] lg:px-[1.5%] rounded-full cursor-pointer'>View all works</div>
                        <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                            <span className="arrow_btn__icon-wrapper">
                                <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                                    <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                </svg>
                                <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                                    <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                                </svg>
                            </span>
                        </div>
                    </div> */}
                </div>
                {/* Our work ends here */}

                {/* Our services starts from here */}
                <div className='mt-[10%] lg:mt-[5%] mx-[3%] lg:mx-[8%]'>
                    <div className='grid grid-cols-1 lg:grid-cols-2 items-center'>
                        <div>
                            <p className='flex items-center'><div className='h-1 w-1 bg-[#F56E0F] rounded-full'></div>&nbsp;Our Services</p>
                            <div className='heading text-4xl md:text-6xl lg:text-7xl my-[2%] uppercase'>
                                <span className='text-[#F56E0F]'>Unlock Growth</span><br />
                                with Our Services
                            </div>
                        </div>

                        <div>At Open Studios, we help brands grow by combining creativity with clarity. Our services
                            are designed to build visibility, trust, and long-term value.</div>
                        </div>

                    {/* <div className='my-[5%] lg:my-[3%]'>
                        <div className='flex items-center justify-between'>
                            <div className='heading text-4xl md:text-6xl lg:text-7xl uppercase'>
                                PHOTOGRAPHY & CINEMATOGRAPHY
                            </div>
                            <button
                                className="group flex items-center justify-center cursor-pointer"
                                onClick={toggleContent1}
                                >
                                <div
                                    className={`
                                    flex items-center justify-center
                                    rounded-full
                                    bg-[#E8E7E7]
                                    h-[10vw] w-[10vw] md:h-[5vw] md:w-[5vw] 
                                    transition-all duration-300
                                    `}
                                >
                                    {isContentVisible1 ? (
                                    <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[4vw] text-[8vw] leading-none">
                                        −
                                    </span>
                                    ) : (
                                    <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[3vw] text-[7vw] leading-none">
                                        +
                                    </span>
                                    )}
                                </div>
                            </button>
                        </div>

                        <div
                            className={`transition-max-height duration-700 ease-in-out overflow-hidden ${isContentVisible1 ? 'max-h-[65vw] lg:max-h-[15vw]' : 'max-h-0'}`}
                        >
                            <div className='grid grid-cols-1 lg:grid-cols-2 my-[5%] lg:my-[2%] gap-[15%]'>
                                <div>
                                    Creating visuals that speak for your brand—across digital, print, and campaigns.
                                </div>
                                <div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>01</span>&nbsp;&nbsp;Professional shoots</p>
                                    </div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>02</span>&nbsp;&nbsp;Architectural | Interior | Model | Jewellery | Hospitality</p>
                                    </div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>03</span>&nbsp;&nbsp;High-quality output with attention to detail</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="my-[5%] lg:my-[3%]">
                    <div className="flex items-center justify-between">
                        <div className="heading text-4xl md:text-6xl lg:text-7xl uppercase">
                            PHOTOGRAPHY & CINEMATOGRAPHY
                        </div>

                        <button
                            className="group flex items-center justify-center cursor-pointer"
                            onClick={() => toggleContent(1)}
                        >
                            <div
                                className="
                                flex items-center justify-center
                                rounded-full
                                bg-[#E8E7E7]
                                h-[10vw] w-[10vw] md:h-[5vw] md:w-[5vw]
                                transition-all duration-300
                                "
                            >
                                {openIndex === 1 ? (
                                    <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[4vw] text-[8vw] leading-none">
                                        −
                                    </span>
                                ) : (
                                    <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[3vw] text-[7vw] leading-none">
                                        +
                                    </span>
                                )}
                            </div>
                        </button>
                    </div>

                    <div
                        className={`transition-all duration-700 ease-in-out overflow-hidden ${
                            openIndex === 1
                                ? 'max-h-[65vw] lg:max-h-[15vw]'
                                : 'max-h-0'
                        }`}
                    >
                        <div className="grid grid-cols-1 lg:grid-cols-2 my-[5%] lg:my-[2%] gap-[15%]">
                            <div>
                                Creating visuals that speak for your brand—across digital, print, and campaigns.
                            </div>

                            <div>
                                <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                    <p><span className="text-[#F56E0F]">01</span>&nbsp;&nbsp;Professional shoots</p>
                                </div>
                                <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                    <p><span className="text-[#F56E0F]">02</span>&nbsp;&nbsp;Architectural | Interior | Model | Jewellery | Hospitality</p>
                                </div>
                                <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                    <p><span className="text-[#F56E0F]">03</span>&nbsp;&nbsp;High-quality output with attention to detail</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                    {/* <div className='my-[5%] lg:my-[3%]'>
                        <div className='flex items-center justify-between'>
                            <div className='heading text-4xl md:text-6xl lg:text-7xl uppercase'>
                                SOCIAL MEDIA
                            </div>
                            <button
                                className="group flex items-center justify-center cursor-pointer"
                                onClick={toggleContent2}
                                >
                                <div
                                    className={`
                                    flex items-center justify-center
                                    rounded-full
                                    bg-[#E8E7E7]
                                    h-[10vw] w-[10vw] md:h-[5vw] md:w-[5vw] 
                                    transition-all duration-300
                                    `}
                                >
                                    {isContentVisible1 ? (
                                    <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[4vw] text-[8vw] leading-none">
                                        −
                                    </span>
                                    ) : (
                                    <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[3vw] text-[7vw] leading-none">
                                        +
                                    </span>
                                    )}
                                </div>
                            </button>
                        </div>

                        <div
                            className={`transition-max-height duration-700 ease-in-out overflow-hidden ${isContentVisible2 ? 'max-h-[75vw] lg:max-h-[15vw]' : 'max-h-0'}`}
                        >
                            <div className='grid grid-cols-1 lg:grid-cols-2 my-[5%] lg:my-[2%] gap-[15%]'>
                                <div>
                                    Strategic content creation and management designed to build engagement and consistency.
                                </div>
                                <div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>01</span>&nbsp;&nbsp;Content planning & execution</p>
                                    </div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>02</span>&nbsp;&nbsp;Platform-specific creatives</p>
                                    </div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>03</span>&nbsp;&nbsp;Brand-aligned storytelling</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="my-[5%] lg:my-[3%]">
                        <div className="flex items-center justify-between">
                            <div className="heading text-4xl md:text-6xl lg:text-7xl uppercase">
                                SOCIAL MEDIA
                            </div>

                            <button
                                className="group flex items-center justify-center cursor-pointer"
                                onClick={() => toggleContent(2)}
                            >
                                <div
                                    className="
                                    flex items-center justify-center
                                    rounded-full
                                    bg-[#E8E7E7]
                                    h-[10vw] w-[10vw] md:h-[5vw] md:w-[5vw]
                                    transition-all duration-300
                                    "
                                >
                                    {openIndex === 2 ? (
                                        <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[4vw] text-[8vw] leading-none">
                                            −
                                        </span>
                                    ) : (
                                        <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[3vw] text-[7vw] leading-none">
                                            +
                                        </span>
                                    )}
                                </div>
                            </button>
                        </div>

                        <div
                            className={`transition-all duration-700 ease-in-out overflow-hidden ${
                                openIndex === 2
                                    ? 'max-h-[75vw] lg:max-h-[15vw]'
                                    : 'max-h-0'
                            }`}
                        >
                            <div className="grid grid-cols-1 lg:grid-cols-2 my-[5%] lg:my-[2%] gap-[15%]">
                                <div>
                                    Strategic content creation and management designed to build engagement and consistency.
                                </div>

                                <div>
                                    <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                        <p>
                                            <span className="text-[#F56E0F]">01</span>&nbsp;&nbsp;
                                            Content planning & execution
                                        </p>
                                    </div>

                                    <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                        <p>
                                            <span className="text-[#F56E0F]">02</span>&nbsp;&nbsp;
                                            Platform-specific creatives
                                        </p>
                                    </div>

                                    <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                        <p>
                                            <span className="text-[#F56E0F]">03</span>&nbsp;&nbsp;
                                            Brand-aligned storytelling
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className='my-[5%] lg:my-[3%]'>
                        <div className='flex items-center justify-between'>
                            <div className='heading text-4xl md:text-6xl lg:text-7xl uppercase'>
                                3D VISUALIZATIONS
                            </div>
                            <button
                                className="group flex items-center justify-center cursor-pointer"
                                onClick={toggleContent3}
                                >
                                <div
                                    className={`
                                    flex items-center justify-center
                                    rounded-full
                                    bg-[#E8E7E7]
                                    h-[10vw] w-[10vw] md:h-[5vw] md:w-[5vw] 
                                    transition-all duration-300
                                    `}
                                >
                                    {isContentVisible1 ? (
                                    <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[4vw] text-[8vw] leading-none">
                                        −
                                    </span>
                                    ) : (
                                    <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[3vw] text-[7vw] leading-none">
                                        +
                                    </span>
                                    )}
                                </div>
                            </button>
                        </div>

                        <div
                            className={`transition-max-height duration-700 ease-in-out overflow-hidden ${isContentVisible3 ? 'max-h-[75vw] lg:max-h-[15vw]' : 'max-h-0'}`}
                        >
                            <div className='grid grid-cols-1 lg:grid-cols-2 my-[5%] lg:my-[2%] gap-[15%]'>
                                <div>
                                    High-end architectural renders and walkthroughs that bring unbuilt spaces to life.
                                </div>
                                <div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>01</span>&nbsp;&nbsp;Exterior & interior renders</p>
                                    </div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>02</span>&nbsp;&nbsp;Walkthroughs & conceptual visuals</p>
                                    </div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>03</span>&nbsp;&nbsp;Detail-driven, realistic output</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="my-[5%] lg:my-[3%]">
                        <div className="flex items-center justify-between">
                            <div className="heading text-4xl md:text-6xl lg:text-7xl uppercase">
                                3D VISUALIZATIONS
                            </div>

                            <button
                                className="group flex items-center justify-center cursor-pointer"
                                onClick={() => toggleContent(3)}
                            >
                                <div
                                    className="
                                    flex items-center justify-center
                                    rounded-full
                                    bg-[#E8E7E7]
                                    h-[10vw] w-[10vw] md:h-[5vw] md:w-[5vw]
                                    transition-all duration-300
                                    "
                                >
                                    {openIndex === 3 ? (
                                        <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[4vw] text-[8vw] leading-none">
                                            −
                                        </span>
                                    ) : (
                                        <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[3vw] text-[7vw] leading-none">
                                            +
                                        </span>
                                    )}
                                </div>
                            </button>
                        </div>

                        <div
                            className={`transition-all duration-700 ease-in-out overflow-hidden ${
                                openIndex === 3
                                    ? 'max-h-[75vw] lg:max-h-[15vw]'
                                    : 'max-h-0'
                            }`}
                        >
                            <div className="grid grid-cols-1 lg:grid-cols-2 my-[5%] lg:my-[2%] gap-[15%]">
                                <div>
                                    High-end architectural renders and walkthroughs that bring unbuilt spaces to life.
                                </div>

                                <div>
                                    <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                        <p>
                                            <span className="text-[#F56E0F]">01</span>&nbsp;&nbsp;
                                            Exterior & interior renders
                                        </p>
                                    </div>

                                    <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                        <p>
                                            <span className="text-[#F56E0F]">02</span>&nbsp;&nbsp;
                                            Walkthroughs & conceptual visuals
                                        </p>
                                    </div>

                                    <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                        <p>
                                            <span className="text-[#F56E0F]">03</span>&nbsp;&nbsp;
                                            Detail-driven, realistic output
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className='my-[5%] lg:my-[3%]'>
                        <div className='flex items-center justify-between'>
                            <div className='heading text-4xl md:text-6xl lg:text-7xl uppercase'>
                                BRAND DESIGN
                            </div>
                            <button
                                className="group flex items-center justify-center cursor-pointer"
                                onClick={toggleContent4}
                                >
                                <div
                                    className={`
                                    flex items-center justify-center
                                    rounded-full
                                    bg-[#E8E7E7]
                                    h-[10vw] w-[10vw] md:h-[5vw] md:w-[5vw] 
                                    transition-all duration-300
                                    `}
                                >
                                    {isContentVisible1 ? (
                                    <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[4vw] text-[8vw] leading-none">
                                        −
                                    </span>
                                    ) : (
                                    <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[3vw] text-[7vw] leading-none">
                                        +
                                    </span>
                                    )}
                                </div>
                            </button>
                        </div>

                        <div
                            className={`transition-max-height duration-700 ease-in-out overflow-hidden ${isContentVisible4 ? 'max-h-[75vw] lg:max-h-[15vw]' : 'max-h-0'}`}
                        >
                            <div className='grid grid-cols-1 lg:grid-cols-2 my-[5%] lg:my-[2%] gap-[15%]'>
                                <div>
                                    Brand identities and visual systems that look premium, consistent, and recognisable.
                                </div>
                                <div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>01</span>&nbsp;&nbsp;Logo & visual identity</p>
                                    </div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>02</span>&nbsp;&nbsp;Brand guidelines</p>
                                    </div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>03</span>&nbsp;&nbsp;Design systems for digital & print</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="my-[5%] lg:my-[3%]">
                        <div className="flex items-center justify-between">
                            <div className="heading text-4xl md:text-6xl lg:text-7xl uppercase">
                                BRAND DESIGN
                            </div>

                            <button
                                className="group flex items-center justify-center cursor-pointer"
                                onClick={() => toggleContent(4)}
                            >
                                <div
                                    className="
                                    flex items-center justify-center
                                    rounded-full
                                    bg-[#E8E7E7]
                                    h-[10vw] w-[10vw] md:h-[5vw] md:w-[5vw]
                                    transition-all duration-300
                                    "
                                >
                                    {openIndex === 4 ? (
                                        <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[4vw] text-[8vw] leading-none">
                                            −
                                        </span>
                                    ) : (
                                        <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[3vw] text-[7vw] leading-none">
                                            +
                                        </span>
                                    )}
                                </div>
                            </button>
                        </div>

                        <div
                            className={`transition-all duration-700 ease-in-out overflow-hidden ${
                                openIndex === 4
                                    ? 'max-h-[75vw] lg:max-h-[15vw]'
                                    : 'max-h-0'
                            }`}
                        >
                            <div className="grid grid-cols-1 lg:grid-cols-2 my-[5%] lg:my-[2%] gap-[15%]">
                                <div>
                                    Brand identities and visual systems that look premium, consistent, and recognisable.
                                </div>

                                <div>
                                    <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                        <p>
                                            <span className="text-[#F56E0F]">01</span>&nbsp;&nbsp;
                                            Logo & visual identity
                                        </p>
                                    </div>

                                    <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                        <p>
                                            <span className="text-[#F56E0F]">02</span>&nbsp;&nbsp;
                                            Brand guidelines
                                        </p>
                                    </div>

                                    <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                        <p>
                                            <span className="text-[#F56E0F]">03</span>&nbsp;&nbsp;
                                            Design systems for digital & print
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className='my-[5%] lg:my-[3%]'>
                        <div className='flex items-center justify-between'>
                            <div className='heading text-4xl md:text-6xl lg:text-7xl uppercase'>
                                BROCHURE CREATION
                            </div>
                            <button
                                className="group flex items-center justify-center cursor-pointer"
                                onClick={toggleContent5}
                                >
                                <div
                                    className={`
                                    flex items-center justify-center
                                    rounded-full
                                    bg-[#E8E7E7]
                                    h-[10vw] w-[10vw] md:h-[5vw] md:w-[5vw] 
                                    transition-all duration-300
                                    `}
                                >
                                    {isContentVisible1 ? (
                                    <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[4vw] text-[8vw] leading-none">
                                        −
                                    </span>
                                    ) : (
                                    <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[3vw] text-[7vw] leading-none">
                                        +
                                    </span>
                                    )}
                                </div>
                            </button>
                        </div>

                        <div
                            className={`transition-max-height duration-700 ease-in-out overflow-hidden ${isContentVisible5 ? 'max-h-[75vw] lg:max-h-[15vw]' : 'max-h-0'}`}
                        >
                            <div className='grid grid-cols-1 lg:grid-cols-2 my-[5%] lg:my-[2%] gap-[15%]'>
                                <div>
                                    Thoughtfully designed brochures that communicate your brand story with clarity and
                                    impact.
                                </div>
                                <div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>01</span>&nbsp;&nbsp;Corporate & brand brochures</p>
                                    </div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>02</span>&nbsp;&nbsp;Real estate & project brochures</p>
                                    </div>
                                    <div className='border-b border-[#B5B3B3] pb-[2%] mb-[2%]'>
                                        <p><span className='text-[#F56E0F]'>03</span>&nbsp;&nbsp;Clean layouts, strong hierarchy, and print-ready files</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="my-[5%] lg:my-[3%]">
                        <div className="flex items-center justify-between">
                            <div className="heading text-4xl md:text-6xl lg:text-7xl uppercase">
                                Brochure Creation
                            </div>

                            <button
                                className="group flex items-center justify-center cursor-pointer"
                                onClick={() => toggleContent(5)}
                            >
                                <div
                                    className="
                                    flex items-center justify-center
                                    rounded-full
                                    bg-[#E8E7E7]
                                    h-[10vw] w-[10vw] md:h-[5vw] md:w-[5vw]
                                    transition-all duration-300
                                    "
                                >
                                    {openIndex === 5 ? (
                                        <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[4vw] text-[8vw] leading-none">
                                            −
                                        </span>
                                    ) : (
                                        <span className="extraFont text-black group-hover:text-[#F56E0F] md:text-[3vw] text-[7vw] leading-none">
                                            +
                                        </span>
                                    )}
                                </div>
                            </button>
                        </div>

                        <div
                            className={`transition-all duration-700 ease-in-out overflow-hidden ${
                                openIndex === 5
                                    ? 'max-h-[75vw] lg:max-h-[15vw]'
                                    : 'max-h-0'
                            }`}
                        >
                            <div className="grid grid-cols-1 lg:grid-cols-2 my-[5%] lg:my-[2%] gap-[15%]">
                                <div>
                                    Thoughtfully designed brochures that communicate your brand story with clarity and
                                    impact.
                                </div>

                                <div>
                                    <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                        <p>
                                            <span className="text-[#F56E0F]">01</span>&nbsp;&nbsp;
                                            Corporate & brand brochures
                                        </p>
                                    </div>

                                    <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                        <p>
                                            <span className="text-[#F56E0F]">02</span>&nbsp;&nbsp;
                                            Real estate & project brochures
                                        </p>
                                    </div>

                                    <div className="border-b border-[#B5B3B3] pb-[2%] mb-[2%]">
                                        <p>
                                            <span className="text-[#F56E0F]">03</span>&nbsp;&nbsp;
                                            Clean layouts, strong hierarchy, and print-ready files
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {/* Our services ends here */}

                {/* Testimonials starts from here */}
                {/* <div className='mt-[10%] lg:mt-[2%] bg-[#1A1919] rounded-2xl py-[2%] lg:py-[1%] px-[3%] lg:px-[8%]'>
                    <div className='grid grid-cols-1 lg:grid-cols-2 items-center'>
                        <div className='mr-[10%]'>
                            <p className='flex items-center text-[#FAF8F8]'><div className='h-1 w-1 bg-[#F56E0F] rounded-full'></div>&nbsp;Testimonials</p>
                            <div className='heading text-4xl md:text-6xl lg:text-7xl my-[2%] text-[#FAF8F8] uppercase'>
                                <span className='text-[#F56E0F]'>Our client like us,</span><br />
                                and we love them
                            </div>

                            <p className='my-[5%] lg:my-[2%] text-[#B5B3B3]'>
                                At Open Studios, our clients’ satisfaction is our top priority. We take pride in the relationships we
                                build and the successes we help create.
                            </p>
                            <p className='text-[#FAF8F8]'>5.0&nbsp;<span className='text-[#B5B3B3]'>from 100 reviewers</span></p>

                            <div className='flex justify-between h-[1em] w-[7em]'>
                                <img src="../assets/Google.png" alt="Img" />
                                <img src="../assets/Stars.png" alt="Img" />
                            </div>
                        </div>

                        <div className='lg:hidden'>
                            <div className='mt-[5%] lg:my-0'>
                                <div className="mobile_testimonial-container">
                                    <div className="mobile_testimonial-list">
                                        <div className="mobile_testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%] w-[16em]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="mobile_testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%] w-[16em]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="mobile_testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%] w-[16em]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="mobile_testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%] w-[16em]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>

                                        <div className="mobile_testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%] w-[16em]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="mobile_testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%] w-[16em]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="mobile_testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%] w-[16em]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="mobile_testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%] w-[16em]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mobile_testimonial-container_reverse">
                                    <div className="mobile_testimonial-list_reverse">
                                        <div className="mobile_testimonial-card_reverse">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%] w-[16em]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="mobile_testimonial-card_reverse">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%] w-[16em]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="mobile_testimonial-card_reverse">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%] w-[16em]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="mobile_testimonial-card_reverse">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%] w-[16em]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="mobile_testimonial-card_reverse">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%] w-[16em]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="mobile_testimonial-card_reverse">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%] w-[16em]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className='hidden lg:block '>
                            <div className='grid grid-cols-2 gap-[2%] mt-[5%] lg:my-0'>
                                <div className="testimonial-container">
                                    <div className="testimonial-list">
                                        <div className="testimonial-card ">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>


                                        <div className="testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="testimonial-card">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="testimonial-container_reverse">
                                    <div className="testimonial-list_reverse">
                                        <div className="testimonial-card_reverse">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="testimonial-card_reverse">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="testimonial-card_reverse">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="testimonial-card_reverse">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="testimonial-card_reverse">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="testimonial-card_reverse">
                                            <div className='bg-[#3A3939] rounded-2xl p-[5%]'>
                                                <img src='../assets/Stars.png' alt="Img" className="w-[30%]" />
                                                <p className="text-[#FAF8F8] my-[8%]">
                                                    Working with this team has been an absolute pleasure. They delivered beyond our expectations, even
                                                    with our tight budget!
                                                </p>
                                                <p className="heading text-[#FAF8F8] text-2xl md:text-4xl 2xl:text-5xl">
                                                    Sarah Johnson
                                                </p>
                                                <p className="text-[#B5B3B3] mt-[5%] lg:mt-[2%]">
                                                    Marketing Manager - Bright Ideas Inc.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div> */}
                {/* Testimonials ends here */}

                {/* FAQ starts from here */}
                {/* <div className='mt-[5%] lg:mt-[2%] mx-[3%] lg:mx-[8%]'>
                    <div className='grid grid-cols-1 lg:grid-cols-2'>
                        <div>
                            <p className='flex items-center'><div className='h-1 w-1 bg-[#F56E0F] rounded-full'></div>&nbsp;Frequently Ask Questions</p>
                            <div className='heading text-4xl md:text-6xl lg:text-7xl my-[2%] text-[#1A1919] uppercase'>The answers to<br />your questions</div>
                        </div>

                        <motion.div
                            className="mt-[0%] lg:mt-[2%]"
                            variants={containerVariants}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.2 }}
                            >

                            <motion.div
                                variants={itemVariants}
                                className={`my-[3%] p-[2%] rounded-2xl cursor-pointer ${
                                activeFAQ === 1 ? 'bg-[#FFF1DB]' : 'bg-[#E8E7E7] hover:bg-[#FFF1DB]'
                                }`}
                                onClick={() => toggleFAQContent(1)}
                            >
                                <div className="flex items-center justify-between">
                                <div className="font-semibold">
                                    How much does social media management cost?
                                </div>
                                <div className="extraFont text-[2em]">
                                    {activeFAQ === 1 ? '-' : <span className="text-[#F56E0F]">+</span>}
                                </div>
                                </div>

                                <motion.div
                                initial={false}
                                animate={{ height: activeFAQ === 1 ? "auto" : 0 }}
                                transition={{ duration: 0.5, ease: "easeInOut" }}
                                className="overflow-hidden"
                                >
                                <div className="my-[5%] lg:my-[2%]">
                                    Unfortunately, we don't have set project prices. Every brief we work on
                                    has different requirements which alters the spec of the job.
                                </div>
                                </motion.div>
                            </motion.div>

                            <motion.div
                                variants={itemVariants}
                                className={`my-[3%] p-[2%] rounded-2xl cursor-pointer ${
                                activeFAQ === 2 ? 'bg-[#FFF1DB]' : 'bg-[#E8E7E7] hover:bg-[#FFF1DB]'
                                }`}
                                onClick={() => toggleFAQContent(2)}
                            >
                                <div className="flex items-center justify-between">
                                <div className="font-semibold">Can you work with our limited budget?</div>
                                <div className="extraFont text-[2em]">
                                    {activeFAQ === 2 ? '-' : <span className="text-[#F56E0F]">+</span>}
                                </div>
                                </div>

                                <motion.div
                                initial={false}
                                animate={{ height: activeFAQ === 2 ? "auto" : 0 }}
                                transition={{ duration: 0.5, ease: "easeInOut" }}
                                className="overflow-hidden"
                                >
                                <div className="my-[5%] lg:my-[2%]">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                </div>
                                </motion.div>
                            </motion.div>

                            <motion.div
                                variants={itemVariants}
                                className={`my-[3%] p-[2%] rounded-2xl cursor-pointer ${
                                activeFAQ === 3 ? 'bg-[#FFF1DB]' : 'bg-[#E8E7E7] hover:bg-[#FFF1DB]'
                                }`}
                                onClick={() => toggleFAQContent(3)}
                            >
                                <div className="flex items-center justify-between">
                                <div className="font-semibold">How long does a shoot project take?</div>
                                <div className="extraFont text-[2em]">
                                    {activeFAQ === 3 ? '-' : <span className="text-[#F56E0F]">+</span>}
                                </div>
                                </div>

                                <motion.div
                                initial={false}
                                animate={{ height: activeFAQ === 3 ? "auto" : 0 }}
                                transition={{ duration: 0.5, ease: "easeInOut" }}
                                className="overflow-hidden"
                                >
                                <div className="my-[5%] lg:my-[2%]">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                </div>
                                </motion.div>
                            </motion.div>

                            <motion.div
                                variants={itemVariants}
                                className={`my-[3%] p-[2%] rounded-2xl cursor-pointer ${
                                activeFAQ === 4 ? 'bg-[#FFF1DB]' : 'bg-[#E8E7E7] hover:bg-[#FFF1DB]'
                                }`}
                                onClick={() => toggleFAQContent(4)}
                            >
                                <div className="flex items-center justify-between">
                                <div className="font-semibold">What are your payment terms?</div>
                                <div className="extraFont text-[2em]">
                                    {activeFAQ === 4 ? '-' : <span className="text-[#F56E0F]">+</span>}
                                </div>
                                </div>

                                <motion.div
                                initial={false}
                                animate={{ height: activeFAQ === 4 ? "auto" : 0 }}
                                transition={{ duration: 0.5, ease: "easeInOut" }}
                                className="overflow-hidden"
                                >
                                <div className="my-[5%] lg:my-[2%]">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                </div>
                                </motion.div>
                            </motion.div>

                            <motion.div
                                variants={itemVariants}
                                className={`my-[3%] p-[2%] rounded-2xl cursor-pointer ${
                                activeFAQ === 5 ? 'bg-[#FFF1DB]' : 'bg-[#E8E7E7] hover:bg-[#FFF1DB]'
                                }`}
                                onClick={() => toggleFAQContent(5)}
                            >
                                <div className="flex items-center justify-between">
                                <div className="font-semibold">Can we arrange a phone call to discuss?</div>
                                <div className="extraFont text-[2em]">
                                    {activeFAQ === 5 ? '-' : <span className="text-[#F56E0F]">+</span>}
                                </div>
                                </div>

                                <motion.div
                                initial={false}
                                animate={{ height: activeFAQ === 5 ? "auto" : 0 }}
                                transition={{ duration: 0.5, ease: "easeInOut" }}
                                className="overflow-hidden"
                                >
                                <div className="my-[5%] lg:my-[2%]">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                </div>
                                </motion.div>
                            </motion.div>

                            </motion.div>
                    </div>
                </div> */}
                {/* FAQ over from here */}
                {/* Social media starts from here */}
                {/* <div className='mt-[5%] lg:mt-[2%] bg-[#F3F1F1] pt-[2%] pb-[4%] px-[3%]'>
                    <div className='grid grid-cols-1 lg:grid-cols-3 items-center overflow-hidden'>
                        <div>
                            grids to be placed when actual images are decided
                        </div>
                        <div>
                            <p className="heading text-5xl md:text-7xl lg:text-8xl 2xl:text-[10rem] uppercase">follow us on social media</p>

                            <div className='grid grid-cols-1 lg:grid-cols-2 gap-[15px] mt-[5%] lg:mt-[2%]'>
                                <button className="instagram_btn">
                                    <span className="instagram_icon">
                                        <svg height="2em" viewBox="0 0 128 128" width="2em" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <linearGradient id="a" gradientTransform="matrix(1 0 0 -1 594 633)" gradientUnits="userSpaceOnUse" x1="-566.711" x2="-493.288" y1="516.569" y2="621.43">
                                                <stop offset="0" stopColor="#ffb900" />
                                                <stop offset="1" stopColor="#9100eb" />
                                            </linearGradient>
                                            <circle cx="64" cy="64" fill="url(#a)" r="64" />
                                            <g fill="#fff">
                                                <path d="m82.333 104h-36.666c-11.947 0-21.667-9.719-21.667-21.667v-36.666c0-11.948 9.72-21.667 21.667-21.667h36.666c11.948 0 21.667 9.719 21.667 21.667v36.667c0 11.947-9.719 21.666-21.667 21.666zm-36.666-73.333c-8.271 0-15 6.729-15 15v36.667c0 8.271 6.729 15 15 15h36.666c8.271 0 15-6.729 15-15v-36.667c0-8.271-6.729-15-15-15z" />
                                                <path d="m64 84c-11.028 0-20-8.973-20-20 0-11.029 8.972-20 20-20s20 8.971 20 20c0 11.027-8.972 20-20 20zm0-33.333c-7.352 0-13.333 5.981-13.333 13.333 0 7.353 5.981 13.333 13.333 13.333s13.333-5.98 13.333-13.333c0-7.352-5.98-13.333-13.333-13.333z" />
                                                <circle cx="85.25" cy="42.75" r="4.583" />
                                            </g>
                                        </svg>
                                    </span>
                                    <span className="instagram_text1">openstudiosco.</span>
                                    <span className="instagram_text2">Instagram</span>
                                </button>

                                <button className="linkedin_btn">
                                    <span className="linkedin_icon">
                                        <svg fill="none" height="2em" viewBox="0 0 120 120" width="2em" xmlns="http://www.w3.org/2000/svg">
                                            <g clipRule="evenodd" fillRule="evenodd">
                                                <path d="m120 60.0002c0 33.1366-26.8633 59.9998-60 59.9998-33.138 0-60-26.8632-60-59.9998 0-33.1376 26.8617-60.0002 60-60.0002 33.1364.00031715 60 26.8626 60 60.0002z" fill="#0077B5"></path>
                                                <g fill="#fff">
                                                    <path d="m63.8771 54.3451c.2959-.3181.411-.4154.4938-.5356 4.0325-5.884 9.7919-7.6141 16.5119-6.5811 7.7657 1.1953 12.7354 6.6312 14.004 14.949.3009 1.9723.4506 3.9525.449 5.9464-.0047 8.2817-.0177 16.563.0178 24.844.0054.9327-.2242 1.2067-1.1801 1.195-4.3386-.052-8.6787-.0514-13.0179 0-.9493.0104-1.1925-.2601-1.1874-1.1944.0352-7.7238.0228-15.4472.0152-23.1703-.0029-1.7554-.1234-3.4997-.6169-5.1996-1.5816-5.4524-7.7846-7.3664-12.2018-3.7408-2.3866 1.9581-3.3196 4.5473-3.3015 7.5947.0386 7.2858.0114 14.5713.0114 21.8571 0 .9558-.0533 1.9146.0162 2.8647.0608.8259-.2766.9848-1.0248.98-4.4194-.0298-8.8379-.033-13.2567.0019-.8017.0063-1.09-.1567-1.0808-1.038.0647-6.5672.091-13.1375.0939-19.7052.0012-8.0822-.0149-16.1637-.0714-24.2455-.006-.8848.1792-1.1465 1.0932-1.1363 4.4194.0495 8.8383.0422 13.2571.0051.7957-.0073 1.0177.2321.9923 1.0063-.0549 1.6656-.0165 3.3335-.0165 5.3026z"></path>
                                                    <path d="m40.1241 71.1028c0 7.2826-.0155 14.5659.0187 21.8491.0038.9045-.1785 1.2264-1.1645 1.2134-4.377-.0584-8.7549-.0447-13.1324-.0079-.8129.0066-1.0869-.1963-1.086-1.0507.0213-14.6861.0178-29.3712-.0041-44.0569-.0009-.765.1856-1.0209.9882-1.0133 4.4579.038 8.9154.0428 13.3722-.0032.8896-.0098 1.0279.3149 1.0244 1.1008-.027 7.3235-.0152 14.6458-.0165 21.9687z"></path>
                                                    <path d="m32.5678 25.8388c5.8726.0064 9.6878 4.6579 8.2959 10.1135-1.0517 4.1194-5.3122 6.491-10.2299 5.6924-5.2234-.8477-8.1348-5.9452-6.21-10.8714 1.2013-3.0767 4.2757-4.9392 8.144-4.9345z"></path>
                                                </g>
                                            </g>
                                        </svg>
                                    </span>
                                    <span className="linkedin_text1">openstudios</span>
                                    <span className="linkedin_text2">LinkedIn</span>
                                </button>

                                <button className="facebook_btn">
                                    <span className="facebook_icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="2em" viewBox="0 0 512 512" height="2em">
                                            <g fillRule="evenodd" clipRule="evenodd">
                                                <path fill="#3a5ba2" d="m256.23 512c140.58 0 255.77-115.19 255.77-255.77 0-141.046-115.19-256.23-255.77-256.23-141.046 0-256.23 115.184-256.23 256.23 0 140.58 115.184 255.77 256.23 255.77z"></path>
                                                <path fill="#fff" d="m224.023 160.085c0-35.372 28.575-63.946 63.938-63.946h48.072v63.946h-32.199c-8.608 0-15.873 7.257-15.873 15.873v32.192h48.072v63.938h-48.072v144.22h-63.938v-144.22h-48.065v-63.938h48.065z"></path>
                                            </g>
                                        </svg>
                                    </span>
                                    <span className="facebook_text1">openstudios</span>
                                    <span className="facebook_text2">Facebook</span>
                                </button>

                                <button className="whatsapp_btn">
                                    <span className="whatsapp_icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="2em" viewBox="0 0 512 512" height="2em">
                                            <g fillRule="evenodd" clipRule="evenodd">
                                                <path fill="#25D366" d="m256.23 512c140.58 0 255.77-115.19 255.77-255.77 0-141.046-115.19-256.23-255.77-256.23-141.046 0-256.23 115.184-256.23 256.23 0 140.58 115.184 255.77 256.23 255.77z"></path>
                                                <path fill="#fff" transform="translate(80, 60) scale(0.75)" d="M391.84 322.51l-85.1-6.5a39.78 39.78 0 0 0-45.15 8.4l-32.91 33.06a317.26 317.26 0 0 1-137.64-137.5l33.13-32.85a39.78 39.78 0 0 0 8.47-45.16l-36.51-85.08a39.87 39.87 0 0 0-45.15-23.16L48.58 10.96a39.84 39.84 0 0 0-38.38 39.94c0 234.88 190.5 425.44 425.42 425.44a39.84 39.84 0 0 0 0 39.88 0 0 0-23.16-45.22z"></path>
                                            </g>
                                        </svg>
                                    </span>
                                    <span className="extraFont whatsapp_text1">+91 9876543210</span>
                                    <span className="whatsapp_text2">WhatsApp</span>
                                </button>

                            </div>
                        </div>
                        <div>
                            grids to be placed when actual images are decided
                        </div>
                    </div>
                </div> */}
                <FollowUs />
            </div>
            <Footer />
        </div>
    );
};

export default Home;
